





















import Vue from 'vue';
import SettingsService from './settings.service'
import { Settings, Response } from '../ordercall'
import Tabs from './components/Tabs.vue'
import SaveBar from './components/SaveBar.vue'
import MainComponent from './components/main/Main.vue'
import MainHeader from './components/header/MainHeader.vue'
import FormComponent from './components/form/Form.vue'
import SmartButtonComponent from './components/smart_button/SmartButton.vue'
import Notification from './components/notification/Notification.vue'
import Analytics from './components/analytics/Analytics.vue'
import Extra from './components/extra/Extra.vue'
import shopOrdercall from '../shop.ordecall'

const settingsService = new SettingsService()

export default Vue.extend({
    data() {
        let settings: Settings = {}
        return {
            shopOrdercall: shopOrdercall,
            load: false,
            saved: false,
            saveTimeout: 0,
            settings: settings,
            tabs: ['Основные настройки', 'Настройки формы', 'Плавающие кнопки', 'Настройки уведомлений', 'Цели для Яндекс.Метрики и Google Analitics'],
            tabAcive: 1,
        }
    },
    components: {
        Tabs,
        MainComponent,
        MainHeader,
        FormComponent,
        SmartButtonComponent,
        Notification,
        Analytics,
        Extra,
        SaveBar
    },
	created() {
        this.getSettings()
    },
	methods: {
        getSettings() {
            settingsService.getSettings().done((res: Response) => {
                this.settings = res.data
                this.load = true
            })
        },
        saveSettings() {
            clearTimeout(this.saveTimeout)
            this.saved = false
            settingsService.saveSettings(this.settings).done((res: Response) => {
                this.saved = true
                this.saveTimeout = setTimeout(() => {
                    this.saved = false
                }, 3000)  
            })
        },
        setTab(index: number) {
            this.tabAcive = index
        }
    }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/settings/Settings.vue